import { useEffect, useState } from "react";
import { ArrivalsMonths, ArrivalsSummary } from "@/components/widgets";
import { Bar, Card, ErrorState, Loading } from "@/components/ui";
import { useArrivals } from "@/lib/queries";
import { useSession } from "@/hooks/useSession";
import { eur } from "@/lib/format";

function useIsNarrow(maxWidth = 639) {
  const query = `(max-width: ${maxWidth}px)`;
  const [narrow, setNarrow] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setNarrow(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return narrow;
}

/** « Arrivages » : récap, historique groupé par mois, répartition par fournisseur. */
export function ArrivagesPage() {
  const { me, isManagerView } = useSession();
  const q = useArrivals();
  const narrow = useIsNarrow();

  if (q.isLoading) return <Loading />;
  if (q.error) return <ErrorState error={q.error} />;
  const d = q.data!;
  const showCity = !isManagerView || me.boutiques.length > 1;

  return (
    <div className="flex flex-wrap gap-4">
      <div className="flex min-w-0 flex-1 basis-[420px] flex-col gap-[18px]">
        <ArrivalsSummary data={d} extended />
        <ArrivalsMonths data={d} showCity={showCity} compact={narrow} />
      </div>
      <Card pad="px-[22px] py-5" className="h-fit w-full flex-shrink-0 md:w-[320px]">
        <div className="mb-3 text-[13.5px] font-bold">Répartition par fournisseur</div>
        {d.suppliers.length === 0 && <div className="text-[12.5px] text-muted">Aucun fournisseur.</div>}
        {d.suppliers.map((f) => (
          <div key={f.name} className="mb-3" title={eur(f.amount)}>
            <div className="flex justify-between gap-3 text-[12px]">
              <span className="min-w-0 truncate">{f.name}</span>
              <span className="flex-shrink-0 font-bold">{Math.round(f.pct)} %</span>
            </div>
            <Bar pct={f.pct} className="mt-[5px]" />
          </div>
        ))}
      </Card>
    </div>
  );
}
